import { render, staticRenderFns } from "./RoutesListItem.vue?vue&type=template&id=f2f337a6&"
import script from "./RoutesListItem.vue?vue&type=script&lang=js&"
export * from "./RoutesListItem.vue?vue&type=script&lang=js&"
import style0 from "./RoutesListItem.vue?vue&type=style&index=0&id=f2f337a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports